import { useCallback, useMemo } from 'react';
import { ACTION_IDS } from 'asset-actions-lib/constants/actionIds';
import useFetchTeamPermissions from './useFetchTeamPermissions';
import useFetchUserPermissions from './useFetchUserPermissions';
import useSaveTeamPermissions from './useSaveTeamPermissions';
import useSaveUserPermissions from './useSaveUserPermissions';
export default function useManageAccessPanel({
  objectId,
  onConfirm,
  objectTypeId,
  crmObject,
  onActionError
}) {
  const {
    loading: teamIdsLoading,
    teamIds,
    error: teamIdsError
  } = useFetchTeamPermissions({
    objectType: objectTypeId,
    objectId
  });
  const {
    loading: userIdsLoading,
    userIds,
    error: userIdsError
  } = useFetchUserPermissions({
    objectType: objectTypeId,
    objectId
  });
  const {
    saveTeamPermissions
  } = useSaveTeamPermissions({
    objectType: objectTypeId,
    objectId
  });
  const {
    saveUserPermissions
  } = useSaveUserPermissions({
    objectType: objectTypeId,
    objectId
  });
  const handleSave = useCallback(({
    selectedTeamIds,
    selectedUserIds
  }) => {
    Promise.all([saveTeamPermissions(selectedTeamIds), saveUserPermissions(selectedUserIds)]).then(() => {
      onConfirm(ACTION_IDS.MANAGE_ACCESS, crmObject);
    }).catch(() => {
      if (onActionError) {
        onActionError({
          actionId: ACTION_IDS.MANAGE_ACCESS,
          data: crmObject
        });
      }
    });
  }, [crmObject, onActionError, onConfirm, saveTeamPermissions, saveUserPermissions]);
  const isLoading = useMemo(() => teamIdsLoading || userIdsLoading, [teamIdsLoading, userIdsLoading]);
  const hasErrors = useMemo(() => teamIdsError || userIdsError, [teamIdsError, userIdsError]);
  return {
    teamIds,
    userIds,
    hasErrors,
    isLoading,
    handleSave
  };
}